import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody } from "reactstrap";
import { SignOut, Check } from "@phosphor-icons/react";

const ActivateModal = ({ show, onActivateClick, onCloseClick, nome }) => {
	return (
		<Modal size="sm" isOpen={show} toggle={onCloseClick} centered={true}>
			<div className="modal-content">
				<ModalBody className="px-4 py-5 text-center">
					<p className="text-muted font-size-16 mb-4">
						Tem certeza de que deseja ativar este plano de ação?
					</p>
					<p className="text-muted font-size-16 mb-4 fw-bold">
						{nome}
					</p>

					<div className="hstack gap-2 justify-content-center mb-0">
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onActivateClick}
						>
							<Check size={16} /> Confirmar
						</Button>
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onCloseClick}
						>
							<SignOut size={16} /> Fechar
						</Button>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};

ActivateModal.propTypes = {
	onCloseClick: PropTypes.func,
	onActivateClick: PropTypes.func,
	show: PropTypes.bool,
	nome: PropTypes.any,
};

export default ActivateModal;

